<script context="module">
    import newUniqueId from 'locally-unique-id-generator'
    import Select from 'svelte-select';

</script>


<script lang="ts">

    import {getValue} from "felte";
    import {myStore} from "../../stores.js";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();


    export let items = [];

    export let disabled = false;

    export let placeholder;

    export let group;
    export let value;
    export let title;

    export let selection;


    export let formField;

    export let formValue;


    export let error;

    let id = newUniqueId();

    let	listOpen = false;

    $: {
        keepListOpenIfFocused(listOpen);
    }

    function keepListOpenIfFocused() {

        const element = document.getElementById(""+id);
        const isFocused = (document.activeElement === element);
        console.log("isFocussed? ", isFocused);
        if (isFocused) listOpen = true;
    }
    function handleSelect(event) {
        console.log("handleSelect (MultiDropdown, data = ", event);
        //     open = true;
        // event.detail will contain the selected value
        //   event.stopPropagation();
        dispatch('select', {
            value: selection
        });

        if(formField){
          $myStore.setData(formField,selection.map((s) =>  s.value));
        }

    }


</script>
<!--<svelte:window on:keypress={handleKey}/>-->
<label for="{id}"  class="multi-select" class:error={error}>
<Select id="{id}"
        hasError={error}
        isDisabled={disabled}
        bind:listOpen on:select={handleSelect}  isMulti isSearchable={false}
        {items} {placeholder} noOptionsMessage="tout sélectionné"
        bind:value={selection}
        --borderRadius="9px"
        --listBorderRadius="9px"
        --inputColor="#474747"
        --indicatorColor="#474747"
        --itemHoverBG="#E7E7E7"
        --itemIsActiveBG="#E7E7E7"
        --itemIsActiveColor="#474747"
        --borderFocusColor="#A4D8FA"
        --multiItemActiveBG="#474747"
        --multiClearHoverFill="#56A8DD"

/>
</label>

<style lang="scss">



  label {
    width:100%;
    position: relative;
    // align-items:center;
    // line-height: normal;

    color:$primary-color;
    background-color: $white;
    //padding: 5px 15px;
    //font-family: sans-serif, Arial;
    font-size: 16px;
    //border: 2px solid transparent;
    border-radius: 9px;

  }

  input[type="radio"]:checked + label {
    //  background-color: #bfb;
    //  border-color: #4c4;
  }

  input[type="radio"]:focus + label {
    //  border: 2px dashed #444;
  }

  label:hover {
    background-color: #dfd;
  }

</style>
